// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"10786591","297":"acafae41","643":"99ed46e0","787":"e0d1cbe3","959":"1042c83a"}[chunkId] + ".chunk.js";
};